import "./App.css";
import Suport from "./Suport_";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return <Router>
    <Routes>
      <Route path="/" element={<Suport/>}/>
    </Routes>
  </Router>;
}

export default App;
